import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { priceCategories } from "@/mocks/prices";

export default function Price() {
  return (
    <section id="price" className="bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="u-container">
        <Reveal>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <SectionHeading en="PRICE" jp="料金を、分かりやすく。" />
            <p className="max-w-sm text-[13px] leading-[2] text-foreground-700">
              各カテゴリの料金をご案内しています。詳しい内容はカテゴリごとにご確認ください。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 border-t border-foreground-950/12 md:mt-16">
          <div className="lg:grid lg:grid-cols-2 lg:gap-x-20">
            {priceCategories.map((category, index) => (
              <Reveal key={category.id} delay={index * 60}>
                <Link
                  to={`/price?tab=${category.id}`}
                  className="group flex items-center justify-between gap-6 border-b border-foreground-950/12 py-7 md:py-8"
                >
                  <span className="flex items-baseline gap-5">
                    <span className="font-label text-[11px] tracking-[0.25em] text-secondary-500">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span>
                      <span className="en-eyebrow block text-[10px] text-foreground-500">{category.en}</span>
                      <span className="mt-2 block font-heading text-lg text-foreground-950 md:text-xl">
                        {category.jp}
                      </span>
                    </span>
                  </span>
                  <span className="flex shrink-0 items-center gap-2 text-[12px] text-foreground-800 transition-colors group-hover:text-accent-700 md:text-[13px]">
                    料金を見る
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={120}>
          <div className="mt-10">
            <Link
              to="/price"
              className="group inline-flex items-center gap-3 border-b border-foreground-950/25 pb-1 text-[13px] text-foreground-900 transition-colors hover:border-accent-600 hover:text-accent-700 md:text-sm"
            >
              すべての料金を見る
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}